import React from 'react';
import CheckboxComponent from "../../reusable/CheckboxComponent";
import {useDispatch, useSelector} from "react-redux";
import {ApplicationState} from "../../../store";
import {SettingsState} from "../../../store/settings/types";
import {setResponsivePane} from "../../../store/settings/actions";
import {APIState} from "../../../store/API/types";

const SettingsResponsivePaneComponent = () => {
    const { paneIsResponsive } = useSelector<ApplicationState, SettingsState>(state => state.settings);
    const { username } = useSelector<ApplicationState, APIState>(state => state.API);
    const dispatch = useDispatch();
    const switchers = [
        {
            name: 'paneIsResponsiveOn',
            value: 'paneIsResponsiveOn',
            label: 'On',
            checked: paneIsResponsive
        },
        {
            name: 'paneIsResponsiveOff',
            value: 'paneIsResponsiveOff',
            label: 'Off',
            checked: !paneIsResponsive
        }
    ];

    const handler = (e: React.FormEvent<HTMLInputElement>) => {
        const flag = e.currentTarget.value === 'paneIsResponsiveOn';
        dispatch(setResponsivePane(flag));
        if (flag) {
            window.localStorage.setItem(`${username}/responsive`, `${flag}`);
        } else {
            window.localStorage.removeItem(`${username}/responsive`);
        }
    };

    return <CheckboxComponent inputs={switchers}
                              title={'Stretch to Fit: '}
                              handler={handler}
    />
};

export default SettingsResponsivePaneComponent